const Module = () => import('./Module.vue')
const Home = () => import('./views/Home.vue')

const moduleRoute = {
  path: '/file-management',
  component: Module,
  children: [
    {
      path: '/',
      name: 'file-management',
      component: Home,
    },
  ],
}

export default router => {
  router.addRoutes([moduleRoute])
}
